/* eslint-disable max-len */
/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2020, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.authorModule', ['ui.router', 'bulbApp.ajaxModule', 'bulbApp.authModule', 'bulbApp.badgesModule',
  'bulbApp.compositeViewModule', 'bulbApp.configModule', 'bulbApp.translateModule'])

  .constant('AUTHOR_TABS', {
    FAMILY: 'family',
    PORTFOLIO: 'portfolio',
    RESUME: 'resume',
  })
  .run(['$rootScope', 'AUTHOR_TABS', run])
  .config(['$stateProvider', 'AUTH', 'AUTHOR_TABS', config]);

function run($rootScope, AUTHOR_TABS) {
  $rootScope.AUTHOR_TABS = AUTHOR_TABS;
}

function config($stateProvider, AUTH, AUTHOR_TABS) {
  $stateProvider
    .state('author', {
      parent: 'root',
      url: '^/{username:[^/?.]{2,}}/{authorTab:(?:family|portfolio|resume)|(?!badges)}?welcome&trial&prepaidCode&verifyEmail&token',
      resolve: {
        BulbAjaxService: 'BulbAjaxService',
        authorAccount: ['$stateParams', 'Restangular', function ($stateParams, Restangular) {
          return Restangular.one('accounts', $stateParams.username).get();
        }],
        authorUnit: ['$stateParams', 'BulbAjaxService', function ($stateParams, BulbAjaxService) {
          return BulbAjaxService.getAuthor($stateParams.username).then((data) => data.unitDTOs[0]);
        }],
        resume: ['authorAccount', 'ResumeService', 'ErrorService', '$state', function (authorAccount, ResumeService, ErrorService, $state) {
          // Fetch the resume if there is one, return null if not or if user disabled the resume tab from accountSettings.
          // If someone is trying to view the resume using the shared link then authorAccount object will not have features
          // and always be undefined so second check will give true and fetch the resume.
          if ((authorAccount.resumeId && !authorAccount.features)
          || (authorAccount.resumeId && authorAccount.features.ResumeFeature.resumeEnabled)) {
            return ResumeService.fetchResume(authorAccount.resumeId).then((resume) => resume, (errorResponse) => {
              if (errorResponse.status == 404) {
                return $state.go('notFound', {}, { location: false });
              }
              // A 403 is a valid response, so it is not an error.  Any other error should be captured.
              if (errorResponse.status !== 403) {
                ErrorService.captureRestangularError(errorResponse);
              }
              return null;
            });
          }
          return null;
        }],
        $title: ['authorUnit', (authorUnit) => authorUnit.name],
      },
      views: {
        content: {
          templateUrl: 'ajs/author/author.html',
          controller: 'AuthorController as authorCtrl',
        },
      },
      bulbAuth: {
        authorizedRoles: [AUTH.ROLES.USER],
      },
      onEnter: ['$stateParams', '$cookies', 'authorUnit', 'BulbUnitService', 'BulbDeletedUnitService', 'RecordEventService', 'authorAccount', 'resume',
        function ($stateParams, $cookies, authorUnit, BulbUnitService, BulbDeletedUnitService, RecordEventService, authorAccount, resume) {
          BulbUnitService.setCurrentUnit(authorUnit);
          BulbDeletedUnitService.authorAccountId = authorAccount.id;

          /**
           * Fire off analytics events based on whether or not the current user is viewing the authorAccounts
           * Portfolio tab in list or grid view. If user blocks cookies, we send an event informing this view is unset
           * which defaults to 'tile'.
           */
          if ($stateParams.authorTab === 'portfolio') {
            const prefCookies = $cookies.get('prefs') ? JSON.parse($cookies.get('prefs')) : {};
            const userPrefs = authorAccount.prefs || prefCookies;
            const viewOptionLabel = userPrefs.useTileViewProfile ? 'tile' : 'list';
            if (userPrefs.useTileViewProfile === true || userPrefs.useTileViewProfile === false) {
              RecordEventService.recordEvent('view_portfolio', 'view_option', viewOptionLabel);
            } else {
              RecordEventService.recordEvent('view_portfolio', 'view_option', 'not_set');
            }
          }

          const accountFeatures = authorAccount.features;
          if (authorAccount.prefs && accountFeatures) {
            // When logged in user view resume using sharable link, the url contains token parameter.
            // When user click on logo to go back to there profile we need to remove that token (BULBAPP-3771).
            if ($stateParams.token) {
              $stateParams.token = undefined;
            }

            const isFamilyAccountEnable = accountFeatures.FamilyFeature.familyAccountEnabled;
            const isResumeFeatureEnable = accountFeatures.ResumeFeature.resumeEnabled;

            if (!$stateParams.authorTab) {
              $stateParams.authorTab = AUTHOR_TABS.PORTFOLIO;
            }
            const currentAuthorTabPath = $stateParams.authorTab;
            if ((currentAuthorTabPath === AUTHOR_TABS.FAMILY && !isFamilyAccountEnable)
              || (currentAuthorTabPath === AUTHOR_TABS.RESUME && !isResumeFeatureEnable)) {
              $stateParams.authorTab = AUTHOR_TABS.PORTFOLIO;
            }
          } else {
          // This else is executed when user view somebody else resume using sharable link
          // and select the portfolio tab and open page/collection and click on resume owner username.
          // Currently, clicking username does not add /resume to url, because there is no default view,
          // resulting in blank resume tab (BULBAPP-3733).
            if (!$stateParams.authorTab && resume !== null) {
              $stateParams.authorTab = AUTHOR_TABS.RESUME;
            }
          }
        }],
      onExit: ['BulbUnitService', function (BulbUnitService) {
        BulbUnitService.setCurrentUnit(null);
      }],
    }).state('author.default', { // This state inherits from author, so the full state name is 'author.default'
      url: '^/{username:[^/?.]{2,}}',
    });
}
